module.exports = __webpack_public_path__ + "static/media/bgr-three-sm.a795bb2a.webp";